import { FilterElement, InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { formatOptionLabel } from '~/lib/util/inquiry.util';

interface ProviderFilterProps {
  ariaLabel: string;
  id: string;
  inputValue: string;
  isLoading?: boolean;
  isSearchable?: boolean;
  isSingleSelect?: boolean;
  label: string;
  onChange: (status: FilterElement[]) => void;
  onInputChange: (value: string) => void;
  onMenuScrollToBottom?: () => void;
  placeholder?: string;
  providerOptions: ProviderOption[];
  value: FilterElement[];
  withCheckBox?: boolean;
}
const ProviderFilter = ({
  ariaLabel,
  id,
  inputValue,
  isLoading = false,
  isSearchable = true,
  isSingleSelect = false,
  label,
  onChange,
  onInputChange,
  onMenuScrollToBottom,
  placeholder = 'Search',
  providerOptions,
  value,
  withCheckBox = true,
}: ProviderFilterProps) => {
  const TOP_LEVEL_ID = `${id}__provider-filter`;
  return (
    <InputGroupV2 id={TOP_LEVEL_ID} label={label}>
      <UniversalSelect
        ariaLabel={ariaLabel}
        formatOptionLabel={formatOptionLabel}
        id={TOP_LEVEL_ID}
        inputValue={inputValue}
        isLoading={isLoading}
        isSearchable={isSearchable}
        isSingleSelect={isSingleSelect}
        onChange={onChange}
        onInputChange={onInputChange}
        onMenuScrollToBottom={onMenuScrollToBottom}
        options={(providerOptions ?? []).map((provider: ProviderOption) => ({
          ...provider,
          label: `${provider.firstName} ${provider.lastName}`,
          value: `${provider.firstName} ${provider.lastName}`,
        }))}
        placeholder={placeholder}
        value={value}
        withCheckBox={withCheckBox}
      />
    </InputGroupV2>
  );
};

export default ProviderFilter;
